export default __webpack_public_path__ + "enterprise-boundaries-xray-960-0a531171c9adbd74690524e02e91a651.png";